// Centralized auth-token access — single choke point so the storage backend can be
// swapped (e.g. httpOnly cookie + in-memory) without touching call sites.
// SECURITY NOTE: JWTs in localStorage are readable by JS (XSS risk). Keeping all
// access here makes a future migration to httpOnly cookies a one-file change.
const TOKEN_KEY = "oxo_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* storage unavailable */
  }
};

export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* storage unavailable */
  }
};
